<script setup>
import VueLoadImage from "vue-load-image";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});
</script>
<template>
  <div>
    <VueLoadImage>
      <template #image>
        <img :src="props.url" role="presentation" alt="" />
      </template>
    </VueLoadImage>
  </div>
</template>
